import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./redux/app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

const container = document.getElementById("root")!;
const root = createRoot(container);

if(process.env.REACT_APP_ENV === 'PRODUCTION') {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}

root.render(
  <Provider store={store}>
      <App />
  </Provider>
);


reportWebVitals();
